import { render, staticRenderFns } from "./editBunkersOnTableCEV.vue?vue&type=template&id=1dfd2418&scoped=true"
import script from "./editBunkersOnTableCEV.vue?vue&type=script&lang=js"
export * from "./editBunkersOnTableCEV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd2418",
  null
  
)

export default component.exports